<script setup>
  import {computed} from "vue";

  import {patientGfralgorithm} from "@pages/Records/Components/Sections/LaborBar/enums.js";
  import {MedTooltip} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "PagesRecordResultPatientDataLaborvalues",
  });

  const props = defineProps({
    laborvalues: {
      type: Object,
      required: true,
    },
    record: {
      type: Object,
      required: true,
    },
  });

  const formatDate = (date) => {
    let newDate = new Date(date);
    if (Number.isNaN(newDate.getTime())) {
      return null;
    }

    return newDate.toLocaleDateString("de-DE", {dateStyle: "medium"});
  };

  const currentLaborValues = computed(() => {
    return props.laborvalues.filter((laborvalue) => {
      return laborvalue.value || (laborvalue.deviation !== null && laborvalue.deviation !== "normal");
    });
  });
</script>

<template>
  <div
    v-if="currentLaborValues.length > 0"
    class="py-2 sm:grid sm:grid-cols-4 sm:gap-4"
    :data-test="getTestId('result-labor-values')"
  >
    <dt class="font-semibold text-gray-900">Labor- / Vitalwerte</dt>

    <dd class="mt-1 text-gray-700 sm:col-span-3 sm:mt-0">
      <ul>
        <!-- @formatter:off -->
        <template v-for="laborvalue in currentLaborValues" :key="laborvalue.id">
          <li class="inline after:content-[',_'] last:after:content-['']">
            <span class="font-semibold">{{ laborvalue.type }}</span>

            <template v-if="laborvalue.deviation">
              <MedTooltip v-if="laborvalue.deviation === 'lowered'" content="erniedrigt">(↓)</MedTooltip>

              <MedTooltip v-else-if="laborvalue.deviation === 'raised'" content="erhöht">(↑)</MedTooltip>

              <MedTooltip v-else-if="laborvalue.deviation === 'normal'" content="normal">(norm.)</MedTooltip>
            </template>

            <span v-if="laborvalue.value">{{ laborvalue.value }} {{ laborvalue.unit }}</span>
            <span v-if="laborvalue.date">
              {{ formatDate(laborvalue.date) }}
            </span>

            <span v-if="laborvalue.type === 'GFR'">
              <template v-if="record.gfralgorithm !== '' && record.gfralgorithm !== null">
                ({{ patientGfralgorithm[record.gfralgorithm] ?? record.gfralgorithm }})
              </template>

              <template v-else>(manuell)</template>
            </span>
          </li>
        </template>
        <!-- @formatter:on -->
      </ul>
    </dd>
  </div>
</template>
